/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
import WorkBenchWorkPackageInfoBox from '@/components/WorkBench/WorkBenchWorkPackageInfoBox.component.vue';
import WaggonInfoNavButton from '@/components/ProjectTaktPlan/WaggonInfoNavButton.component.vue';
import WorkBenchWorkPackageHeader from '@/components/WorkBench/WorkBenchWorkPackageHeader.component.vue';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';

import StandardStep from '@/components/StandardComponents/StandardStep.component.vue';

// import axios from 'axios';

export const WorkBenchWorkPackageInfoBoxMixin = {
  components: {
    WorkBenchWorkPackageInfoBox,
    WaggonInfoNavButton,
    WorkBenchWorkPackageHeader,
    StandardDataField,
    StandardFlexBox,

    StandardStep,
  },
  data: () => ({
    nav_direction: 'right',
    nav_direction_image: 'right',
  }),
  computed: {
    outer_prefix(){
      switch (this.$route.params.template_type) {
        case 'custom':
          return '';
        case 'company':
          return 'b';
        case 'community':
          return 'c';
      }
    },
    prefix(){
      switch (this.$route.params.info_box_template_type) {
        case 'custom':
          return '';
        case 'company':
          return 'b';
        case 'community':
          return 'c';
      }
    },
    step_prefix(){
      switch (this.$route.params.info_box_template_type) {
        case 'custom':
          return 'w';
        case 'company':
          return 'bw';
        case 'community':
          return 'cw';
      }
    },
    work_package(){
      if (this.$route.params.workpackage_id === 'create') {
        return this.$store.getters['WorkBenchLocal/getWBLObject']({
          path: [
            {workpackage: ''},
          ]
        });
      } else {
        return this.$store.getters['WorkBench/getWBObject']({
          type: `${this.prefix}workpackages`,
          id: this.$route.params.workpackage_id
        });
      }
    },
    steps(){
      if (this.step_type === 'nosteps') {
        return [];
      }
      let step_string = `${this.step_prefix}${this.step_type}`;
      if (this.$route.params.info_box_template_type === 'recommendation') {
        return this.$store.getters['WorkBench/getWBObject']({
          type: 'workpackagerecommendations',
          id: this.$route.params.waggon_id
        }).workpackages[this.$route.params.workpackage_id][step_string]
      } else {
        return this.$store.getters['WorkBench/getWBObjects']({
          type: step_string,
          ids: this.work_package[step_string],
        })
      }
    },
    work_steps() {
      return this.work_package[`${this.step_prefix}worksteps`];
    },
    quality_steps() {
      return this.work_package[`${this.step_prefix}qualitysteps`];
    },
    defect_steps() {
      return this.work_package[`${this.step_prefix}defectsteps`];
    },
    handover_steps() {
      return this.work_package[`${this.step_prefix}handoversteps`];
    },
    design_steps() {
      return this.work_package[`${this.step_prefix}designsteps`];
    },
    logistic_steps() {
      return this.work_package[`${this.step_prefix}logisticsteps`];
    },
    material_steps() {
      return this.work_package[`${this.step_prefix}materialsteps`];
    },
    getWaggonInfoNavigation: function() {
      let switch_var = '';
      let switch_route = '';
      if (this.template_type === 'swaggonrecommendation') {
        switch_var = this.$route.matched[4].name;
        switch_route = 'RecommendedWaggonWorkPackage';
      } else {
        if (this.$route.matched[6]) {
          switch_var = this.$route.matched[6].name;
          switch_route = `${this.location}WorkPackageInfoBox`;
        } else {
          switch_var = this.$route.matched[5].name;
          switch_route = `${this.location}WaggonWorkPackageInfoBox`;
        }
      }
      switch (switch_var) {
        case `${switch_route}Info`:
          return {
            up: false,
            right: `${switch_route}Images`,
            down: `${switch_route}WorkSteps`,
            left: `${switch_route}Costs`,
          };
        case `${switch_route}WorkSteps`:
          return {
            up: `${switch_route}Info`,
            right: `${switch_route}Images`,
            down: `${switch_route}QualitySteps`,
            left: `${switch_route}Costs`,
          };
        case `${switch_route}QualitySteps`:
          return {
            up: `${switch_route}WorkSteps`,
            right: `${switch_route}Images`,
            down: `${switch_route}DefectSteps`,
            left: `${switch_route}Costs`,
          };
        case `${switch_route}DefectSteps`:
          return {
            up: `${switch_route}QualitySteps`,
            right: `${switch_route}Images`,
            down: `${switch_route}HandoverSteps`,
            left: `${switch_route}Costs`,
          };
        case `${switch_route}HandoverSteps`:
          return {
            up: `${switch_route}DefectSteps`,
            right: `${switch_route}Images`,
            down: `${switch_route}DesignSteps`,
            left: `${switch_route}Costs`,
          };
        case `${switch_route}DesignSteps`:
          return {
            up: `${switch_route}HandoverSteps`,
            right: `${switch_route}Images`,
            down: `${switch_route}LogisticSteps`,
            left: `${switch_route}Costs`,
          };
        case `${switch_route}LogisticSteps`:
          return {
            up: `${switch_route}DesignSteps`,
            right: `${switch_route}Images`,
            down: `${switch_route}NoSteps`,
            left: `${switch_route}Costs`,
          };
        case `${switch_route}NoSteps`:
          return {
            up: `${switch_route}DefectSteps`,
            right: `${switch_route}Images`,
            down: false,
            left: `${switch_route}Costs`,
          };
        case `${switch_route}Images`:
          return {
            up: false,
            right: false,
            down: false,
            left: `${switch_route}WorkSteps`,
          };
        case `${switch_route}Costs`:
          return {
            up: false,
            right: `${switch_route}Info`,
            down: false,
            left: false,
          };
        default:
          return {
            up: false,
            right: false,
            down: false,
            left: false,
          };
      }
    },
    ...mapGetters('WorkBench', [
      'getWBObjects',
    ]),
  },
  methods: {
    getNestedWorkPackageAdd() {
      let work_package = JSON.parse(JSON.stringify(this.work_package));
      [
        `worksteps`,
        `defectsteps`,
        `qualitysteps`,
        `handoversteps`,
        `logisticsteps`,
        `designsteps`,
        `materialsteps`,
        `machinesteps`,
        `workpackageimages`,
      ].forEach(type => {
        work_package[`${this.prefix}s${type}`] = this.getWBObjects({
          type: `${this.prefix}w${type}`,
          ids: this.work_package[`${this.prefix}w${type}`]
        });
        delete work_package[`${this.prefix}w${type}`];
      });
      return work_package;
    },
    getNestedWorkPackageAddToWaggon() {
      let work_package = JSON.parse(JSON.stringify(this.work_package));
      [
        `worksteps`,
        `defectsteps`,
        `qualitysteps`,
        `handoversteps`,
        `logisticsteps`,
        `designsteps`,
        `materialsteps`,
        `machinesteps`,
        `workpackageimages`,
      ].forEach(type => {
        work_package[`${this.prefix}${type}`] = this.getWBObjects({
          type: `${this.prefix}w${type}`,
          ids: this.work_package[`${this.prefix}w${type}`]
        });
        delete work_package[`${this.prefix}w${type}`];
      });
      return work_package;
    },
    getNestedWorkPackageCreateSequence(workpackage){
      return new Promise((resolve_complete) => {
      let work_package = JSON.parse(JSON.stringify(workpackage));
        [
          `worksteps`,
          `defectsteps`,
          `qualitysteps`,
          `handoversteps`,
          `logisticsteps`,
          `designsteps`,
          `materialsteps`,
          `machinesteps`,
          `workpackageimages`,
        ].forEach(type => {
          if (!['recommendation', 'swaggonrecommendation'].includes(this.template_type)) {
            work_package[`s${type}`] = this.getWBObjects({
              type: `${this.prefix}w${type}`,
              ids: work_package[`${this.prefix}w${type}`]
            });
            delete work_package[`${this.prefix}w${type}`];
          }
        });
        // delete work_package.created;
        // delete work_package.id;
        // delete work_package.owner;
        // delete work_package.updated;
        work_package.hashtags = [];
        // for (let i = 0; i < work_package.hashtags.length; i++) {
        //   work_package.hashtags.splice(i, 1, {tag: work_package.hashtags[i].tag});
        // }
        let calls = [];
        work_package.sworkpackageimages.forEach(image => {
          calls.push(
            new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open("GET", image.image);
            xhr.responseType = "blob";
            xhr.onload = function()
            {
               if (xhr.readyState === 4) {
                   if (xhr.status === 200) {
                       resolve(xhr.response);
                   }
                   else {
                       reject(xhr.statusText);
                   }
               } else {
                   reject(xhr.statusText);
               }
              };
              xhr.setRequestHeader("mode", "no-cors");
              xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
              xhr.send();
            })
          );
        });
        Promise.all(calls)
        .then(resps => {
          for (let i = 0; i < resps.length; i++) {
            let file = new File([resps[i]], "image");
            work_package.sworkpackageimages[i].file = file;
            work_package.sworkpackageimages[i].local_url = URL.createObjectURL(file);
          }
          resolve_complete(work_package);
        });
      });
    },
    getNestedWorkPackageCreateWaggon(workpackage){
      return new Promise((resolve_complete) => {
      let work_package = JSON.parse(JSON.stringify(workpackage));
        [
          `worksteps`,
          `defectsteps`,
          `qualitysteps`,
          `handoversteps`,
          `logisticsteps`,
          `designsteps`,
          `materialsteps`,
          `machinesteps`,
          `workpackageimages`,
        ].forEach(type => {
          if (!['recommendation', 'swaggonrecommendation'].includes(this.template_type)) {
            work_package[`wag${type}`] = this.getWBObjects({
              type: `${this.prefix}w${type}`,
              ids: work_package[`${this.prefix}w${type}`]
            });
            delete work_package[`${this.prefix}w${type}`];
          }
        });
        // delete work_package.created;
        // delete work_package.id;
        // delete work_package.owner;
        // delete work_package.updated;
        work_package.hashtags = [];
        // for (let i = 0; i < work_package.hashtags.length; i++) {
        //   work_package.hashtags.splice(i, 1, {tag: work_package.hashtags[i].tag});
        // }

        resolve_complete(work_package);

        // let calls = [];
        // work_package.sworkpackageimages.forEach(image => {
        //   calls.push(
        //     new Promise((resolve, reject) => {
        //     let xhr = new XMLHttpRequest();
        //     xhr.open("GET", image.image);
        //     xhr.responseType = "blob";
        //     xhr.onload = function()
        //     {
        //        if (xhr.readyState === 4) {
        //            if (xhr.status === 200) {
        //                resolve(xhr.response);
        //            }
        //            else {
        //                reject(xhr.statusText);
        //            }
        //        } else {
        //            reject(xhr.statusText);
        //        }
        //       };
        //       xhr.setRequestHeader("mode", "no-cors");
        //       xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
        //       xhr.send();
        //     })
        //   );
        // });
        // Promise.all(calls)
        // .then(resps => {
        //   for (let i = 0; i < resps.length; i++) {
        //     let file = new File([resps[i]], "image");
        //     work_package.sworkpackageimages[i].file = file;
        //     work_package.sworkpackageimages[i].local_url = URL.createObjectURL(file);
        //   }
        //   resolve_complete(work_package);
        // });
      });
    },
    getNestedWorkPackageCreate(workpackage, copy_steps){
      return new Promise((resolve_complete) => {
      let work_package = JSON.parse(JSON.stringify(workpackage));
        [
          `worksteps`,
          `defectsteps`,
          `qualitysteps`,
          `handoversteps`,
          `logisticsteps`,
          `designsteps`,
          `materialsteps`,
          `machinesteps`,
          `workpackageimages`,
        ].forEach(type => {
          if (['recommendation', 'swaggonrecommendation'].includes(this.template_type)) {
            work_package[`w${type}`] = work_package[`s${type}`]?work_package[`s${type}`]:[];
            delete work_package[`s${type}`];
          }
          else {
            if (copy_steps) {
              work_package[`w${type}`] = this.getWBObjects({
                  type: `${this.prefix}w${type}`,
                  ids: work_package[`${this.prefix}w${type}`]
                });
            } else {
              work_package[`w${type}`] = [];
            }
            if (this.template_type !== 'custom') {
              delete work_package[`${this.prefix}w${type}`];
            }
          }
        });
        // delete work_package.created;
        // delete work_package.id;
        // delete work_package.owner;
        // delete work_package.updated;
        work_package.hashtags = [];
        // for (let i = 0; i < work_package.hashtags.length; i++) {
        //   work_package.hashtags.splice(i, 1, {tag: work_package.hashtags[i].tag});
        // }
        let calls = [];
        work_package.wworkpackageimages.forEach(image => {
          calls.push(
            new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open("GET", image.image);
            xhr.responseType = "blob";
            xhr.onload = function()
            {
               if (xhr.readyState === 4) {
                   if (xhr.status === 200) {
                       resolve(xhr.response);
                   }
                   else {
                       console.error(xhr.statusText);
                       reject(xhr.statusText);
                   }
               } else {
                   reject(xhr.statusText);
               }
              };
              xhr.setRequestHeader("mode", "no-cors");
              xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
              xhr.send();
            })
          );
        });
        Promise.all(calls)
        .then(resps => {
          for (let i = 0; i < resps.length; i++) {
            let file = new File([resps[i]], "image");
            work_package.wworkpackageimages[i].file = file;
            work_package.wworkpackageimages[i].local_url = URL.createObjectURL(file);
          }
          resolve_complete(work_package);
        });
      });
    },
    ...mapActions('WorkBench', [
      'createWBObject',
    ]),
    ...mapActions('WorkBenchLocal', [
      'createWBLObject',
      'updateWBLObject'
    ]),
  }
};
